import { Injectable } from '@angular/core';
import { IdampHttpClient } from '../common/IdampHttpClient';

export interface AttestationContextResponse {
    servicePrincipalObjectId: string;
    servicePrincipalDisplayName: string;
    permissionId: string;
    permissionName: string;
    resourceName: string;
    resourceServicePrincipalId: string;
    permissionType: string;
    permissionTier: string;
    permissionDescription: string;
    isFullCycle: boolean;
    previousJustification?: string;
    previousCycleStatus?: string;
    graphLastSignInDate?: string;
    permissionGrantedDate?: string;
}

export interface AttestationBatchContextResponse {
    servicePrincipalObjectId: string;
    servicePrincipalDisplayName: string;
    permissionTier: string;
    campaignId: string;
    lightweightPermissions: AttestationContextResponse[];
    fullCyclePermissions: AttestationContextResponse[];
}

export interface AttestationEvaluateRequest {
    permissionName: string;
    justification: string;
    servicePrincipalObjectId?: string;
    permissionId?: string;
    resourceName?: string;
    resourceServicePrincipalId?: string;
    campaignId?: string;
}

export type AttestationDecision = 'Accepted' | 'NeedsMoreDetail' | 'Unsubstantiated';

export interface AttestationEvaluateResponse {
    decision: AttestationDecision;
    explanation?: string;
    clarificationQuestions?: string[];
}

export interface SubmitAttestationRequest {
    servicePrincipalObjectId: string;
    campaignId: string;
    permissionId: string;
    resourceName?: string;
    resourceServicePrincipalId?: string;
    justification: string;
    isFullCycle: boolean;
    cycleStatus: string;
    escalationReason?: string;
}

export interface AttestationCampaignSummary {
    campaignId: string;
    servicePrincipalObjectId: string;
    servicePrincipalDisplayName: string;
    permissionTier: string;
    status: string;
    initiatedDate: string;
    permissionCount: number;
}

@Injectable({ providedIn: 'root' })
export class AttestationService {

    constructor(private http: IdampHttpClient) { }

    getBatchContext(campaignId: string, spObjectId: string): Promise<AttestationBatchContextResponse> {
        return this.http.GetAsync<AttestationBatchContextResponse>('attestation/context/batch', { campaignId, spObjectId });
    }

    getMyCampaigns(): Promise<AttestationCampaignSummary[]> {
        return this.http.GetAsync<AttestationCampaignSummary[]>('attestation/my-campaigns');
    }

    evaluate(request: AttestationEvaluateRequest): Promise<AttestationEvaluateResponse> {
        return this.http.PostAsync<AttestationEvaluateRequest, AttestationEvaluateResponse>('attestation/evaluate', request);
    }

    submit(request: SubmitAttestationRequest): Promise<any> {
        return this.http.PostAsync<SubmitAttestationRequest, any>('attestation/submit', request);
    }

    escalate(request: SubmitAttestationRequest): Promise<any> {
        return this.http.PostAsync<SubmitAttestationRequest, any>('attestation/escalate', request);
    }
}
